<template>
    <v-app class="login">
        <v-content>
            <v-container fluid fill-height>
                <router-view></router-view>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: 'login-layout'
}
</script>

<style lang="stylus" scoped>
    .login
        height: 100vh
        background: rgb(255, 255, 255)
        background: -moz-linear-gradient(360deg, rgba(255, 255, 255, 1) 50%, rgba(10, 71, 146, 1) 50%)
        background: -webkit-linear-gradient(360deg, rgba(255, 255, 255, 1) 50%, rgba(10,71,146,1) 50%)
        background: linear-gradient(360deg, rgba(255, 255, 255, 1) 50%, rgba(10, 71, 146, 1) 50%)
        filter: unqoute("progid:dximagetransform.microsoft.gradient(startColorstr="#ffffff", endColorstr="#0a4792", GradientType=1)")
</style>
